import { render, staticRenderFns } from "./IntroActivity.vue?vue&type=template&id=500cd48c&scoped=true&"
import script from "./IntroActivity.vue?vue&type=script&lang=js&"
export * from "./IntroActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../less/store.less?vue&type=style&index=0&id=500cd48c&lang=less&scoped=true&"
import style1 from "../../../less/complex.less?vue&type=style&index=1&id=500cd48c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500cd48c",
  null
  
)

export default component.exports